import React from 'react';
import { Link } from 'react-router-dom';

const terms = [
  {
    title: '1. Acceptance of Terms',
    body: 'By creating an account or using Nexora, you agree to follow these Terms & Conditions and our Privacy & Policy. If you do not agree, please do not use the service.'
  },
  {
    title: '2. Eligibility and Account Security',
    body: 'You are responsible for providing accurate information and keeping your login credentials secure. Do not share your password or allow another person to use your account. You are responsible for activity performed through your account.'
  },
  {
    title: '3. Acceptable Use',
    body: 'You must use Nexora lawfully and respectfully. You may not use the service for harassment, threats, fraud, spam, impersonation, unauthorized access, distribution of harmful content, or any activity that violates applicable law.'
  },
  {
    title: '4. User Content',
    body: 'You retain responsibility for the messages, files, images, posts, and other content you share through Nexora. You must have the right to share that content and must not upload content that infringes another person’s rights.'
  },
  {
    title: '5. Calls, Messages, and Availability',
    body: 'Nexora may provide messaging, voice, video, community, and notification features. Availability and quality may vary depending on your device, network, permissions, and third-party services. We may change, suspend, or improve features when necessary.'
  },
  {
    title: '6. Privacy',
    body: 'Our Privacy & Policy explains how we collect, use, and protect information. By using Nexora, you acknowledge that your information may be processed as described in that policy.'
  },
  {
    title: '7. Account Suspension or Termination',
    body: 'We may suspend or terminate an account if it violates these terms, creates a security risk, harms other users, or is involved in illegal activity. You may stop using Nexora and request account closure at any time.'
  },
  {
    title: '8. Disclaimer and Limitation of Liability',
    body: 'Nexora is provided on an “as available” basis. To the extent permitted by law, we are not responsible for service interruptions, network failures, loss of content, or indirect damages resulting from your use of the service.'
  },
  {
    title: '9. Changes to These Terms',
    body: 'We may update these Terms & Conditions to reflect changes to the service, law, or security practices. Continued use of Nexora after an update means you accept the revised terms.'
  }
];

const TermsConditions = () => (
  <main className="terms-page">
    <style>{`
      .terms-page {
        min-height: 100vh;
        padding: 28px 20px 48px;
        background: var(--terms-bg, #f8fafc);
        color: var(--terms-text, #0f172a);
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      }
      :root[data-theme="dark"] .terms-page {
        --terms-bg: #000000;
        --terms-surface: #181818;
        --terms-text: #f8fafc;
        --terms-muted: #a1a1aa;
        --terms-border: #2a2a2a;
      }
      .terms-shell { width: 100%; max-width: 780px; margin: 0 auto; }
      .terms-back { display: inline-flex; margin-bottom: 24px; color: #16a34a; font-size: 14px; font-weight: 700; text-decoration: none; }
      .terms-header { padding: 30px; border-radius: 24px; background: var(--terms-surface, #ffffff); border: 1px solid var(--terms-border, #e2e8f0); box-shadow: 0 16px 40px rgba(15, 23, 42, 0.06); }
      .terms-kicker { margin: 0 0 8px; color: #16a34a; font-size: 12px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; }
      .terms-title { margin: 0; font-size: clamp(28px, 6vw, 42px); line-height: 1.1; }
      .terms-intro { margin: 14px 0 0; color: var(--terms-muted, #64748b); font-size: 15px; line-height: 1.7; }
      .terms-updated { margin: 18px 0 0; color: var(--terms-muted, #64748b); font-size: 12px; }
      .terms-content { margin-top: 18px; padding: 10px 30px; border-radius: 24px; background: var(--terms-surface, #ffffff); border: 1px solid var(--terms-border, #e2e8f0); }
      .terms-section { padding: 22px 0; border-bottom: 1px solid var(--terms-border, #e2e8f0); }
      .terms-section:last-child { border-bottom: 0; }
      .terms-section h2 { margin: 0 0 8px; font-size: 17px; }
      .terms-section p { margin: 0; color: var(--terms-muted, #64748b); font-size: 14px; line-height: 1.8; }
      .terms-contact { margin: 18px 0 0; padding: 22px 30px; border-left: 4px solid #22c55e; border-radius: 4px 16px 16px 4px; background: var(--terms-surface, #ffffff); border-top: 1px solid var(--terms-border, #e2e8f0); border-right: 1px solid var(--terms-border, #e2e8f0); border-bottom: 1px solid var(--terms-border, #e2e8f0); }
      .terms-contact p { margin: 6px 0 0; color: var(--terms-muted, #64748b); font-size: 14px; line-height: 1.7; }
      @media (max-width: 560px) { .terms-page { padding: 20px 14px 36px; } .terms-header { padding: 24px 20px; } .terms-content { padding: 8px 20px; } .terms-contact { padding: 20px; } }
    `}</style>

    <div className="terms-shell">
      <Link to="/register" className="terms-back">← Back to Registration</Link>

      <header className="terms-header">
        <p className="terms-kicker">Nexora User Agreement</p>
        <h1 className="terms-title">Terms &amp; Conditions</h1>
        <p className="terms-intro">Please read these terms carefully before creating your Nexora account or using our services.</p>
        <p className="terms-updated">Last updated: September 9, 2026</p>
      </header>

      <section className="terms-content">
        {terms.map(term => (
          <article className="terms-section" key={term.title}>
            <h2>{term.title}</h2>
            <p>{term.body}</p>
          </article>
        ))}
      </section>

      <section className="terms-contact">
        <strong>Questions?</strong>
        <p>For questions about these terms, contact us at <a href="mailto:official@nexora.community" style={{ color: '#16a34a', fontWeight: 700 }}>official@nexora.community</a>.</p>
      </section>
    </div>
  </main>
);

export default TermsConditions;